import React, { useEffect, useRef } from 'react';
import { AppButton } from '../AppButton/AppButton';
import './DateFilter.css';

/**
 * props:
 * - onClick
 * - startDate
 * - endDate
 */
function DateFilter(props) {
    function getDate(timestamp) {
        const date = timestamp ? new Date(timestamp) : new Date();
        return new Intl.DateTimeFormat('en-GB').format(date);
    }

    const startDateRef = useRef('');
    const endDateRef = useRef('');

    useEffect(() => {
        new window.Datepicker(document.getElementById('startDate'), {
            buttonClass: 'btn',
            format: 'dd/mm/yyyy',
        });

        new window.Datepicker(document.getElementById('endDate'), {
            buttonClass: 'btn',
            format: 'dd/mm/yyyy',
        });
    }, []);

    useEffect(() => {
        startDateRef.current.value = props.startDate
            ? getDate(props.startDate)
            : getDate(Date.now() - (30 * 24 * 60 * 60 * 1000));
        endDateRef.current.value = props.endDate ? getDate(props.endDate) : getDate();
    }, [props.startDate, props.endDate]);

    function parseDate(str) {
        const split = str.split('/');
        return new Date(`${split[1]}/${split[0]}/${split[2]}`);
    }

    function onButtonClick() {
        props.onClick({
            target: {
                id: 'dates',
                value: {
                    startDate: parseDate(startDateRef.current.value),
                    endDate: parseDate(endDateRef.current.value),
                },
            },
        });
    }

    return (
        <div className="date-filter">
            <div className="date-filter__inputs">
                <div className="date-filter__field">
                    <label htmlFor="startDate" className="date-filter__label">From</label>
                    <input
                        ref={startDateRef}
                        data-datepicker=""
                        className="form-control date-filter__input"
                        id="startDate"
                        type="text"
                        placeholder="dd/mm/yyyy"
                        aria-label="Start date"
                    />
                </div>
                <div className="date-filter__field">
                    <label htmlFor="endDate" className="date-filter__label">To</label>
                    <input
                        ref={endDateRef}
                        data-datepicker=""
                        className="form-control date-filter__input"
                        id="endDate"
                        type="text"
                        placeholder="dd/mm/yyyy"
                        aria-label="End date"
                    />
                </div>
            </div>
            <AppButton
                type="button"
                id="btnfilter"
                variant="primary"
                size="md"
                className="date-filter__apply"
                onClick={onButtonClick}
            >
                Apply
            </AppButton>
        </div>
    );
}

export default DateFilter;